import { useLazyQuery } from '@apollo/client';
import { GET_COMPONENT } from 'graphql/secure/queries';
import { GET_CHAIN_MAPPING } from 'graphql/secure/queries/chain.queries';
import React, { FC, useEffect } from 'react';
import { useParams, useMatch } from 'react-router-dom';
import { IChainResponse } from 'FeatureModules/ComponentChain/types/chain.types';
import { IComponentItem } from 'FeatureModules/ComponentChain/types/component.types';
import { TRouteParamsWithId } from 'types/router.types';

/**
 * This can either be a component or a component chain title
 */
const DrawerComponentItemTitle: FC = () => {
  const { id } = useParams<TRouteParamsWithId>();
  const isComponentChain = useMatch('/component-chains/:id/*');

  const [getComponentItem, { data: componentItemData }] = useLazyQuery<{
    component: IComponentItem;
  }>(GET_COMPONENT);

  const [getComponentChain, { data: componentChainResult, loading }] =
    useLazyQuery<IChainResponse>(GET_CHAIN_MAPPING);

  const fetchTitle = () =>
    !isComponentChain
      ? getComponentItem({ variables: { id } })
      : getComponentChain({ variables: { id } });

  useEffect(() => {
    if (!id) {
      return;
    }
    fetchTitle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]); // Id is need since changing from component to component chain need to refetch the correct item with that id

  if (isComponentChain) {
    if (loading || !componentChainResult) {
      return <span>Loading..</span>;
    }

    return <span>{componentChainResult.chain.title}</span>;
  }

  return <span>{componentItemData?.component?.title || 'Loading..'}</span>;
};

export default DrawerComponentItemTitle;
